<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="className"
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8.33333 6.66675L5.58925 9.41083C5.26382 9.73626 5.26382 10.2639 5.58925 10.5893L8.33333 13.3334M14.1666 6.66675L11.4225 9.41083C11.0971 9.73626 11.0971 10.2639 11.4225 10.5893L14.1666 13.3334"
      class="stroke-current"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'ChevronDoubleLeftIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    },
    className: {
      type: String,
      default: 'text-icon-normal'
    }
  }
}
</script>

<style scoped></style>
